import template   from './buy-product.html'
import controller from './buy-product.controller'
import './buy-product.styl'

let component = {
  restrict: 'E',
  bindings: {
    productRef: '<',
    voucherInfos: '<',
    isFreeProduct: '<'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/buy-product.component.js